import React, { Component } from 'react';
import jwt_decode from "jwt-decode";
import { Table } from 'react-bootstrap';
import { withRouter} from 'react-router-dom';
import { CSVLink } from "react-csv";
import { FaFileCsv, FaFilePdf } from 'react-icons/fa';
import jsPDF from 'jspdf'
import 'jspdf-autotable'

import mixin from '../../../utils/mixin';

import { getLotsByDevelopment, getSettingsStatus } from '../../../api/Api.js';

import NavbarMenu from '../NavbarMenu/NavbarMenu.js';

import './Reports.scss';

const {methods} = mixin;

class Reports extends Component {

  constructor(props){
    
    super(props);

    let dev = localStorage.getItem('dev');
    if(dev == null || dev == undefined || dev == ''){
      this.props.history.push("/admin");
      window.location.reload();
    }

    dev = JSON.parse(dev);
    
    let token = localStorage.getItem('jwt');

    if(token){
      const decoded = jwt_decode(token);
      let date = new Date(decoded.exp * 1000);
      let mydate = new Date();
      
      if (date <= mydate) {
        this.logout();
      }
    }else{
      this.logout();
    }

    methods.G_changeLanguage('es');

    this.state = {
      loading: false,
      lots: [],
      status_array: [],
      development_id:  dev.development_id,
      development: dev,
    }
  }

  

  logout = () => {
    localStorage.removeItem("jwt");
    localStorage.removeItem("user");
    localStorage.removeItem("developments");
    this.props.history.push("/admin/login");
    window.location.reload();
  }

  getFillColor(p){
    let status =  this.state.status_array ? this.state.status_array.find(x => x.key == p.status) : null;
    
    if(status){
      return [status.red,status.green,status.blue];
    }
    
    return [108,117,125];    
  }

  dispatchLots = () => new Promise((resolve, reject) => {
    // const { developmentId } = this.state
    getLotsByDevelopment({
      development_id: this.state.development_id
    }).then((res) => {
      let lots = [];
      if (res) {
          lots = res;
      }
      this.setState({
        lots: lots ,
      }, () => resolve('lots data ok'));
    });
  });

  componentDidMount() {
    
    this.setState({
      loading: true
    }, () => {
      Promise.all([this.dispatchLots()]).then(values => {
        
        this.setState({
            loading: false,
        });

      }, reason => {
          console.info(reason)
      });
    });

    getSettingsStatus().then(
      (res) => {
        this.setState({
          status_array: res,
        });
      }
    );
  }

  renderSimplePrice = (price) => {
    if(price){
      return(
        <span>{methods.G_renderPrice(price, 'MXN')} </span>
      )
    }
    return(
      <span>-</span>
    )
  }

  renderSimplePriceAmount = (price) => {
    if(price){
      return(
        methods.G_renderPrice(price, 'MXN')
      )
    }
    return(
      '-'
    )
  }

  renderStatusLabel = (object) => {
    let status =  this.state.status_array ? this.state.status_array.find(x => x.key == object.status) : null;
    let label = status ? status.label : '-';
    
    if(object.status == 'SOLD' && object.hasOwnProperty('confirmed') && object.confirmed === false){
      label = 'Apartado en Proceso';
    }

    let color = this.getFillColor(object);
    color = 'rgb(' + color[0] + ',' + color[1] + ',' + color[2] + ')';

    return (
      <span style={{backgroundColor: color, color:'white', fontSize:'12px', padding:'3px', borderRadius:'5px'}}>{label}</span>
    )
  }

  renderStatusSimpleLabel = (object) => {
    let status =  this.state.status_array ? this.state.status_array.find(x => x.key == object.status) : null;
    let label = status ? status.label : '-';

    return (
      label
    )
  }

  renderLotsTable = () => {
    let lots = (this.state.lots && this.state.lots.length > 0) ? [...this.state.lots] : [];
    let dev = this.state.development;

    lots.sort(function (a, b) {
      if(dev.is_vertical){
        var aTower = a.tower_number;
        var bTower = b.tower_number;
        var aStory = a.story_number;
        var bStory = b.story_number;
        var aBlock = a.block;
        var bBlock = b.block;
        var aNumber = a.number;
        var bNumber = b.number;
        
        if(aTower == bTower){
          if(aStory == bStory){
            if(aBlock == bBlock){
                return (aNumber < bNumber) ? -1 : (aNumber > bNumber) ? 1 : 0;
            }else{
                return (aBlock < bBlock) ? -1 : 1;
            }
          }else{
              return (aStory < bStory) ? -1 : 1;
          }
        }else{
          return (aTower < bTower) ? -1 : 1;
        }
      }else{
        var aBlock = a.block;
        var bBlock = b.block;
        var aNumber = a.number;
        var bNumber = b.number;
        
        
        if(aBlock == bBlock){
            return (aNumber < bNumber) ? -1 : (aNumber > bNumber) ? 1 : 0;
        }else{
            return (aBlock < bBlock) ? -1 : 1;
        }
      }
    });

    const listLots = lots ? lots.map((i) => {
      let area = '-';
      let price_m2 = null;
      let lot_price = null;

      if(i.metadata){
        let meta = [];
        for(let j = 0; j < i.metadata.length; j++){
          for (const [key, value] of Object.entries(i.metadata[j])) {
            meta[key] = value;
          }
        }

        area = meta['AREA'] ? meta['AREA'] : '-';
        price_m2 = meta['PRICE_M2'] ? meta['PRICE_M2'] : null;
        lot_price = null;
        if(area != '-' && price_m2 != null){
          lot_price = parseFloat(area) * parseFloat(price_m2);
          lot_price = lot_price.toFixed(2);
        }
      }

      return( 
        <tr className="lot-item" key={i._id}>
          <td>{i.name}</td>
          <td style={{ textAlign: 'center'}}>{i.block}</td>
          {
            this.state.development &&
            this.state.development.is_vertical &&
            i.tower &&
            <td style={{ textAlign: 'center'}}>{i.tower.name}</td>
          }
          {
            this.state.development &&
            this.state.development.is_vertical &&
            !i.tower &&
            <td style={{ textAlign: 'center'}}>-</td>
          }
          {
            this.state.development &&
            this.state.development.is_vertical &&
            <td style={{ textAlign: 'center'}}>{i.story_number}</td>
          }
          <td style={{ textAlign: 'center'}}>{i.number}</td>
          <td style={{ textAlign:'center' }}>{this.renderStatusLabel(i)}</td>
          <td style={{ textAlign:'center' }}>{area}</td>
          <td style={{ textAlign:'center' }}>{this.renderSimplePrice(price_m2)}</td>
          <td style={{ textAlign:'center' }}>{this.renderSimplePrice(lot_price)}</td>
        </tr>
      )
    }) : [];

    if(listLots.length > 0){
      return (
        <Table responsive striped bordered hover size="sm" id="tx_table" className="mt-4">
          <thead>
            <tr>
              <th>Lote</th>
              <th style={{ textAlign: 'center'}}>Manzana</th>
              {
                this.state.development &&
                this.state.development.is_vertical &&
                <th style={{ textAlign: 'center'}}>Edificio</th>
              }
              {
                this.state.development &&
                this.state.development.is_vertical &&
                <th style={{ textAlign: 'center'}}>Piso</th>
              }
              <th style={{ textAlign: 'center'}}>Número</th>
              <th style={{ textAlign: 'center'}}>Estatus</th>
              <th style={{ textAlign: 'center'}}>Área (m2)</th>
              <th style={{ textAlign: 'center'}}>Precio m2</th>
              <th style={{ textAlign: 'center'}}>Precio Lote</th>
            </tr>
          </thead>
          <tbody>
            {listLots}
          </tbody>
        </Table>
      );
    }else{
      return (
        <span>No hay ningún lote configurado.</span>
      );
    }

  }

  getFileName = () => {
    return 'Inventario_' + methods.G_simpleFormatDateOnly({date: new Date(), separator: '-'});
  }

  exportPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape"
    });
    doc.setFontSize(14);
    doc.text("Inventario", 15, 10);
    doc.setFontSize(10);
    doc.text("Fecha: " + methods.G_simpleFormatDateOnly({date: new Date()}), 15, 20);
    
    if(this.state.lots.length > 0){
      doc.autoTable({ headStyles: { fillColor: [75, 92, 115] }, startY: 26, html: '#tx_table' })
    }else{
      doc.text("No hay lotes registrados.", 15, 26);
    }
    
    doc.save(this.getFileName() + ".pdf");
  }

  getCSVData = () => {
    let csvData = [];

    csvData.push(['Fecha:', methods.G_simpleFormatDateOnly({date: new Date()})]);

    csvData.push([]);

    let headers = []
    headers.push('Lote');
    headers.push('Manzana');
    if(this.state.development && this.state.development.is_vertical){
      headers.push('Edificio');
      headers.push('Piso');
    }
    headers.push('Número');
    headers.push('Estatus');
    headers.push('Área (m2)');
    headers.push('Precio m2');
    headers.push('Precio Lote');

    csvData.push(headers);

    if(this.state.lots && this.state.lots.length > 0){
      const listLots = this.state.lots ? this.state.lots.map((i) => {

        let area = '-';
        let price_m2 = null;
        let lot_price = null;

        if(i.metadata){
          let meta = [];
          for(let j = 0; j < i.metadata.length; j++){
            for (const [key, value] of Object.entries(i.metadata[j])) {
              meta[key] = value;
            }
          }

          area = meta['AREA'] ? meta['AREA'] : '-';
          price_m2 = meta['PRICE_M2'] ? meta['PRICE_M2'] : null;
          lot_price = null;
          if(area != '-' && price_m2 != null){
            lot_price = parseFloat(area) * parseFloat(price_m2);
            lot_price = lot_price.toFixed(2);
          }
        }

        let response = []

        response.push()
      
        response.push(i.name);
        response.push(i.block);
        if(this.state.development && this.state.development.is_vertical){
          response.push(i.tower.name);
          response.push(i.story_number);  
        }
        response.push(i.number);
        response.push(this.renderStatusSimpleLabel(i));
        response.push(area);
        response.push(this.renderSimplePriceAmount(price_m2));
        response.push(this.renderSimplePriceAmount(lot_price));

        return response;
      }) : [];

      if(listLots){
        csvData = csvData.concat(listLots)
      }
    }

    return csvData;
  }
  
  render() {
      const { lots, loading } = this.state;

      if (loading) {
        return (
          <div className="h-100">
            <NavbarMenu development={this.state.development} logout={this.logout} />
            <div className="container-fluid pt-4 h-100">
              Cargando...
            </div>
          </div>
        );
      }

      return (
        <div className="h-100">
          <NavbarMenu development={this.state.development} logout={this.logout} />
          <div className="container-fluid h-100 ext-container">
            <div className="row h-100">
              <div className="col-12 pt-4 pb-5 only-panel ">
                <h3>Inventario</h3>
                <br/>
                <div className="export-btns-container">
                  <CSVLink className="" data={this.getCSVData()} filename={this.getFileName() + '.csv'}><button className="btn btn-cust-green"><FaFileCsv /> CSV</button></CSVLink>
                  <button className="btn btn-cust-red ml-3" onClick={this.exportPDF}><FaFilePdf /> PDF</button>
                </div>
                {this.renderLotsTable()}
              </div>  
            </div>
            
          </div>
        </div>
      );
  }

}

export default withRouter(Reports);
